export default "__VITE_ASSET__OX3GFhkq__"